import React from 'react';
import SiteHeader from './components/SiteHeader';
import ArticleHeader from './components/ArticleHeader';
import AuthorDescription from './components/AuthorDescription';
import Footer from './components/Footer';
import CategoryHeader from './components/CategoryHeader';
import FeaturedArticle from './components/FeaturedArticle';
import ArticlesSection from './components/ArticlesSection';
import SportCategoryHeader from './components/SportCategoryHeader';

import ReactDom from 'react-dom/client';
import { createBrowserRouter, RouterProvider} from 'react-router-dom';

function App() {
  return (
    <div className="App">
    </div>
  );
}

export default App;
